<template>
  <div id="recruit">
    <Header></Header>
    <RecruitmentInformation></RecruitmentInformation>
    <our-jobs></our-jobs>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/Header";
import RecruitmentInformation from "../components/recruitment/RecruitmentInformation";
import OurJobs from "../components/recruitment/OurJobs";
import Footer from "../components/Footer";
export default {
  name: "Recruit",
  components: {
    Header,
    RecruitmentInformation,
    OurJobs,
    Footer
  },
  mounted() {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }
};
</script>

<style scoped></style>
